import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyC22fKI2zpRrjNW6-BZoqmGK8nFBWZbBk8",
    authDomain: "react-messenger-570da.firebaseapp.com",
    databaseURL: "https://react-messenger-570da.firebaseio.com",
    projectId: "react-messenger-570da",
    storageBucket: "react-messenger-570da.appspot.com",
    messagingSenderId: "891238104924",
    appId: "1:891238104924:web:6b0cad388b1b40a8"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;

// service firebase.storage {
//   match /b/{bucket}/o {
//     match /{allPaths=**} {
//       allow read, write: if request.auth != null;
//     }
//   }
// }



// WEBPACK FOOTER //
// ./src/firebase.js